const delay = (delay: number) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve("content delayed");
    }, delay);
  });

export default delay;
